import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { VisitorRegistrationSummaryComponent } from './component/visitor-registration-summary.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';



@NgModule({
  declarations: [
    VisitorRegistrationSummaryComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIElementsModule,
    CommonLayoutModule
  ]
})
export class VisitorRegistrationSummaryModule { }
